import type { IconSvgObject } from './types';

const SleevelessIcon: IconSvgObject = [
  ["path", { d: "M15 2C14.2026 2.60753 13.1571 3.00292 12.0099 3.00292C10.8626 3.00292 9.79744 2.60753 9 2", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 9V21C4 21.5523 4.44772 22 5 22H19C19.5523 22 20 21.5523 20 21V9C19 8.5 17.5 7 17.5 3L15 2C15 5 14 7.40702 12 7.40702C10 7.40702 9 5 9 2L6.5 3C6.5 7 5 8.5 4 9Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default SleevelessIcon;
